import { Link } from 'react-router-dom'
import { MdOutlineHomeWork } from "react-icons/md"
import { GrServices } from "react-icons/gr"
import utils from '../../utils'

function HomeCTA() {
    return (
        <section className="bg-[#1B4D3E] py-24 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <p className="text-orange-500 text-xs uppercase tracking-[0.3em] mb-4 font-semibold">
                        Welcome to {utils.siteName}
                    </p>
                    <h2 className="font-serif text-4xl md:text-6xl text-white mb-6 leading-tight">
                        Your Comfort, <span className="text-orange-500 italic">Our Promise</span>
                    </h2>
                    <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                        Whether you're seeking a furnished home in Kisumu or planning a memorable event,
                        we craft experiences that feel like home.
                    </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">

                    <Link
                        to="/houses"
                        className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
                    >
                        <div className="flex items-start justify-between mb-6">
                            <div className="bg-orange-500/20 p-4 rounded-xl">
                                <MdOutlineHomeWork className="h-8 w-8 text-orange-500" />
                            </div>
                            <span className="text-white/40 text-xs uppercase tracking-widest">13+ Units</span>
                        </div>
                        <h3 className="font-serif text-2xl text-white mb-3 group-hover:text-orange-500 transition-colors">
                            Find Your Stay
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed mb-6">
                            Short & long-term furnished apartments with modern amenities,
                            Lake Victoria views, and 24/7 concierge.
                        </p>
                        <div className="flex items-center text-orange-500 text-sm font-semibold uppercase tracking-widest group-hover:gap-3 transition-all">
                            Browse Houses
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </Link>

                    <Link
                        to="/services"
                        className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
                    >
                        <div className="flex items-start justify-between mb-6">
                            <div className="bg-orange-500/20 p-4 rounded-xl">
                                <GrServices className="h-8 w-8 text-orange-500" />
                            </div>
                            <span className="text-white/40 text-xs uppercase tracking-widest">Curated</span>
                        </div>
                        <h3 className="font-serif text-2xl text-white mb-3 group-hover:text-orange-500 transition-colors">
                            Plan Your Event
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed mb-6">
                            Corporate retreats, private celebrations, or venue management.
                            Full catering and coordination services tailored to you.
                        </p>
                        <div className="flex items-center text-orange-500 text-sm font-semibold uppercase tracking-widest group-hover:gap-3 transition-all">
                            Explore Services
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </Link>

                </div>
                <div className="mt-12 text-center">
                    <p className="text-white/40 text-xs tracking-wide">
                        ✓ Free Wi-Fi &nbsp;•&nbsp; ✓ M-Pesa Accepted &nbsp;•&nbsp; ✓ Free Cancellation up to 48hrs
                    </p>
                </div>
            </div>
        </section>
    )
}

export default HomeCTA